export default __webpack_public_path__ + "static/media/txt1_sp.1398e746.png";